import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const QrBlock = styled.div`
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 24px;
    gap: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.tablet}) {
        display: none;
    }
`;

export const QrSide = styled.div`
    padding: 15px;
    border: 1px solid ${COLORS.BgSubstrate};
    border-radius: ${BorderRadius.componentRadius};
    background-color: ${COLORS.BgMain};

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 14px;
    }
`;

export const QrInner = styled.div`
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 176px;
    height: 176px;
    padding: 12px;
    border: 2px solid ${COLORS.Outline_Light};
    border-radius: 12px;
    background-color: transparent;

    & svg {
        max-width: 148px;
        max-height: 148px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 162px;
        height: 162px;
        padding: 5px;
    }
`;

export const ErrorMessage = styled.p`
    ${FONTS.XXS};
    color: ${COLORS.TextHint};
    margin-bottom: 12px;
    text-align: center;
`;

export const SupportLink = styled.span`
    ${FONTS.MediumXXS};
    color: ${COLORS.Link};
`;

export const QrButton = styled(BaseButton)`
    width: 100%;
`;

export const InfoSide = styled.div`
    flex-direction: column;
`;

export const InfoTitle = styled.h5`
    ${FONTS.H5};
    margin-bottom: 12px;
`;

export const PayButton = styled(BaseButton)<{ isAuth: boolean }>`
    ${({ isAuth }) => isAuth && css`
        margin-top: 20px;
    `};
`;
